import React, { useState } from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import { tags_utils } from '../utils/frfr-tags-utils';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';
import UniFormgenTagBtn from './UniFormgenTagBtn';


// UniFormgenSpecialTagsCsv


//
const _custom_hook = (value, _update_tags_csv) => {
  let tags_csv = '';
  if (typeof value === 'string') {
    tags_csv = value;
  }
  const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(tags_csv);
  const [newTag, setNewTag] = useState();

  const _add_new_tag = (new_tag) => {
    const fixed_tag = tags_utils.fix_tag_lowercase(new_tag);
    if (fixed_tag !== '') {
      if (tags_utils.is_tag_exist_in_tags_arr(tags_arr, fixed_tag)) {
        // tag already exist
      } else { // add new tag
        const updated_tags_arr = [...tags_arr, fixed_tag];
        // const updated_tags_csv = updated_tags_arr.join(tags_utils.TAGS_CSV_SEPARATOR);
        const updated_tags_csv = tags_utils.convert_tags_arr_to_tags_csv(updated_tags_arr);
        // console.log('_add_new_tag', fixed_tag);
        // console.log('updated_tags_arr', updated_tags_arr);
        // console.log('updated_tags_csv', updated_tags_csv);
        _update_tags_csv(updated_tags_csv);
      }
    }
    // RESET newTag input state
    setNewTag('');
  };

  const handleChangeNewTagInput = (e) => {
    const value = e.target.value;
    if (typeof value === 'string') {
      const exploded_tag = value.split(tags_utils.TAGS_CSV_SEPARATOR);
      if (exploded_tag.length > 1) { // user entered comma ',' character
        const prepared_tag = exploded_tag[0]; // TODO
        // console.log(prepared_tag);
        _add_new_tag(prepared_tag);
        return;
      }
    }
    setNewTag(value);
  };

  const handleSubmitNewTagForm = (e) => { // user pressed enter
    e.preventDefault(); // Disables the default browser POST/GET action
    // console.log('submit tag', newTag);
    if (typeof newTag === 'string') {
      const exploded_tag = newTag.split(tags_utils.TAGS_CSV_SEPARATOR);
      const prepared_tag = exploded_tag[0]; // TODO
      // console.log(prepared_tag);
      _add_new_tag(prepared_tag);
    }
  };

  //
  const _handleTagDelete = (target_tag) => {
    // setFormStateMeta(state => {
    if (true) {
      const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(tags_csv);
      // if (tags_arr.includes(target_tag)) {
      // if (tags_utils.is_tag_exist_in_tags_csv(tags_csv, target_tag)) {
      if (tags_utils.is_tag_exist_in_tags_arr(tags_arr, target_tag)) {
        const updated_tags_arr = tags_arr.filter(item => {
          // if (tag === target_tag) {
          if (item.toLowerCase() === target_tag.toLowerCase()) {
            // BINGO match CASE INSENSITIVE
            return false; // delete
          }
          return true; // all other stay
        });
        // const updated_tags_csv = updated_tags_arr.join(tags_utils.TAGS_CSV_SEPARATOR);
        const updated_tags_csv = tags_utils.convert_tags_arr_to_tags_csv(updated_tags_arr);
        /*
        return {
          ...state,
          tags_csv: updated_tags_csv,
        };
        */
        _update_tags_csv(updated_tags_csv);
      }
    }
    // 
    // return state; // return unchanged
    // });
  };

  return {
    tags_arr,
    newTag,
    handleChangeNewTagInput,
    handleSubmitNewTagForm,
    _handleTagDelete,
  };
};


// DEFAULT COMPONENT
const UniFormgenSpecialTagsCsv = (props) => {
  // const timeoutRef = useRef(null);
  // const [clAnimation, setClAnimation] = useState("");

  const {
    warningtip,
    // valueToDisplay,
  } = useFormGeneratorField(props);

  //
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let disabled = false;
  if (params.disabled === true) {
    disabled = true;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
    disabled = true; //
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }

  /*
  useEffect(() => {
    // animate when value change
    setClAnimation(" uniformcompo__field--animate-value-changed");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      //
      setClAnimation("");
    }, 334);
    // componentWillUnmount
    return () => clearTimeout(timeoutRef.current);
  }, [formState[name]]);
  */

  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }
  if (readonly === true) {
    // FIX (According to HTML specs, the select tag in HTML doesn't have a readonly attribute, only a disabled attribute.)
    // handleChange = () => { }; // disable handle change for readonly
    handleChange = null; // disable handle change for readonly
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  // let cl = 'uniformcompo__field' + clAnimation + extraClass;
  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  let infotip = 'name: ' + name;

  let placeholder = null;
  if (typeof params.placeholder === 'string' && params.name !== '') {
    placeholder = params.placeholder;
  }

  //

  const value = formState[name];

  //
  // let _handleChange = (e) => {
  const _update_tags_csv = (value) => {
    let virtual_e = {
      target: {
        name: name,
        value: value
      }
    }
    handleChange(virtual_e);
  };
  //
  const {
    tags_arr,
    newTag,
    handleChangeNewTagInput,
    handleSubmitNewTagForm,
    _handleTagDelete,
  } = _custom_hook(value, _update_tags_csv);
  //

  return (
    <div className={cl} style={style}>
      {/*<label htmlFor={name}>{params.label}</label>*/}
      <label htmlFor={name}>
        {
          tooltip ? (<abbr title={tooltip}>{params.label}</abbr>) : (params.label)
        }
      </label>
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }
      <UniFormcompoErrorInField error={formErrors[name]} />

      <div className="uniformcompo__widget-tags-csv">
        <div className="uniformcompo__widget-tags-csv__fake-input">
          <div className="uniformcompo__widget-tags-csv__tags-vector">
            {
              tags_arr.map((tag, index) => {
                return (
                  <UniFormgenTagBtn
                    title={tag}
                    added
                    withDelete
                    handleClickDelete={() => { _handleTagDelete(tag) }}
                  />
                );
              })
            }
            <div className="uniformcompo__widget-tags-csv__fake-input__real-input-container">
              <form onSubmit={handleSubmitNewTagForm}>
                <input
                  className="uniformcompo__widget-tags-csv__fake-input__real-input"
                  type="text"
                  name={"fake_input"}
                  value={newTag}
                  onChange={handleChangeNewTagInput}
                />
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UniFormgenSpecialTagsCsv;